"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestOrganizationSetSeats = exports.requestOrganizationSeatsPreview = exports.SEATS_EXPECTED_ERRORS = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const apollo_1 = require("@app/util/apollo");
const expected_errors_1 = require("@app/request/auth/expected-errors");
/**
 * Backend codes the seats modal renders inline instead of toasting.
 */
exports.SEATS_EXPECTED_ERRORS = Object.freeze({
    // fewer licences than the organization currently has employees
    BELOW_EMPLOYEE_COUNT: 'organization.seatsBelowEmployeeCount',
    // in trial the licence count follows the employee count on its own
    MANAGED_IN_TRIAL: 'organization.seatsManagedInTrial',
    // the card charge for added licences failed — the message carries Stripe's reason
    PAYMENT_FAILED: 'organization.seatsPaymentFailed',
});
const EXPECTED_ERRORS = Object.values(exports.SEATS_EXPECTED_ERRORS);
const ORGANIZATION_SEATS_PREVIEW_QUERY = (0, graphql_tag_1.default) `
  query OrganizationSeatsPreviewQuery($organization: ID!, $seats: Int!) {
    organizationSeatsPreview(organization: $organization, seats: $seats) {
      seats
      amountDue
      currency
    }
  }
`;
/**
 * What changing the licence count to `seats` charges right away. `amountDue` is in the minor
 * unit of `currency` (haléře for CZK). Removing licences never refunds, so it is 0 then.
 */
const requestOrganizationSeatsPreview = async (variables, errorsCallback) => {
    const { data, errors } = await (0, apollo_1.query)(ORGANIZATION_SEATS_PREVIEW_QUERY, { variables });
    (0, expected_errors_1.processUnexpectedErrors)(errors, EXPECTED_ERRORS);
    errorsCallback?.(errors);
    return data?.organizationSeatsPreview ?? undefined;
};
exports.requestOrganizationSeatsPreview = requestOrganizationSeatsPreview;
const ORGANIZATION_SET_SEATS_MUTATION = (0, graphql_tag_1.default) `
  mutation OrganizationSetSeatsMutation($organization: ID!, $seats: Int!) {
    organizationSetSeats(organization: $organization, seats: $seats)
  }
`;
/**
 * Sets the TOTAL licence count (not a difference) and returns the new count. Sending the
 * current count again changes nothing.
 */
const requestOrganizationSetSeats = async (variables, errorsCallback) => {
    const { data, errors } = await (0, apollo_1.mutate)(ORGANIZATION_SET_SEATS_MUTATION, { variables });
    (0, expected_errors_1.processUnexpectedErrors)(errors, EXPECTED_ERRORS);
    errorsCallback?.(errors);
    return data?.organizationSetSeats ?? undefined;
};
exports.requestOrganizationSetSeats = requestOrganizationSetSeats;
